import axiosInstance from '../api/axios';
import type {
  Appeal,
  AppealBacklogStatistics,
  AppealProcessingStatistics,
  DailyOpenAppealsResponse,
  RejectAppealPayload,
  ResolveAppealSuccessPayload,
} from '@/types/appeal';

export const appealsService = {
  getProcessingStatistics: async () => {
    const response = await axiosInstance.get<AppealProcessingStatistics>('/appeals/processing-statistics');
    return response.data;
  },

  getAppeals: async (params?: { pending?: boolean; merchant_id?: string }) => {
    const response = await axiosInstance.get<Appeal[]>('/appeals', { params });
    return response.data;
  },

  getStatistics: async (slaMinutes = 120) => {
    const response = await axiosInstance.get<AppealBacklogStatistics>('/appeals/statistics', {
      params: { sla_minutes: slaMinutes },
    });
    return response.data;
  },

  getDailyOpenAppeals: async (day: string) => {
    const response = await axiosInstance.get<DailyOpenAppealsResponse>('/appeals/open-daily', {
      params: { day },
    });
    return response.data;
  },

  updateStatus: async (appealId: number, status: string) => {
    const response = await axiosInstance.patch(`/appeals/${appealId}/status`, { status });
    return response.data;
  },

  resolveSuccess: async (appealId: number, payload: ResolveAppealSuccessPayload) => {
    const response = await axiosInstance.post(`/appeals/${appealId}/resolve-success`, payload);
    return response.data;
  },

  reject: async (appealId: number, payload: RejectAppealPayload) => {
    const response = await axiosInstance.post(`/appeals/${appealId}/reject`, payload);
    return response.data;
  },

  claim: async (appealId: number) => {
    const response = await axiosInstance.post(`/appeals/${appealId}/claim`);
    return response.data;
  },

  release: async (appealId: number) => {
    const response = await axiosInstance.delete(`/appeals/${appealId}/claim`);
    return response.data;
  },

  getHistory: async (params?: { trader_id?: string; transaction_id?: string; page?: number; page_size?: number }) => {
    const response = await axiosInstance.get<{
      items: Appeal[];
      total: number;
      page: number;
      page_size: number;
    }>('/appeals/history', { params });
    return response.data;
  },

  getTransactionFiles: async (transactionId: string) => {
    const response = await axiosInstance.get<Appeal[]>(
      `/appeals/transaction/${transactionId}/files`,
    );
    return response.data;
  },

  resetWorkState: async (appealId: number) => {
    const response = await axiosInstance.delete(`/appeals/${appealId}/work-state`);
    return response.data;
  },
};
